<template>
  <v-app class="login-layout-page">
    <HeaderToolbar
      :renderSideIcon="false"
      :renderRightMenuButtons="false"
    />
    <v-content>
      <v-container fill-height>
        <slot />
      </v-container>
      <SnackbarNotification />
    </v-content>
    <SatFooter />
  </v-app>
</template>

<script>
import SnackbarNotification from '@/components/common/SnackbarNotification.vue';
import SatFooter from '@/components/common/Footer.vue';
import HeaderToolbar from '@/components/common/HeaderToolbar.vue';

export default {
  components: {
    SnackbarNotification,
    SatFooter,
    HeaderToolbar,
  },
};
</script>

<style lang="scss">
  .login-layout-page {
    main{
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
</style>
